import { inject, Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({ providedIn: "root" })
export class IconsService {
  /**
   * Constructor
   */
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);

    // Register icon sets
    matIconRegistry.addSvgIconSet(
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/material-twotone.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "mat_outline",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/material-outline.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "mat_solid",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/material-solid.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "feather",
      domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/feather.svg")
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "custom_icon",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/custom-icon.svg"
      )
    );
    matIconRegistry.addSvgIconInNamespace(
      "custom_icon",
      "NavMonitoring",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/sideNavIcons/NavMonitoring.svg"
      )
    );
    matIconRegistry.addSvgIconInNamespace(
      "custom_icon",
      "NavOperation",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/sideNavIcons/NavOperation.svg"
      )
    );
    matIconRegistry.addSvgIconInNamespace(
      "custom_icon",
      "NavDevices",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/sideNavIcons/NavDevices.svg"
      )
    );
    matIconRegistry.addSvgIconInNamespace(
      "custom_icon",
      "NavUsers",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/sideNavIcons/NavUsers.svg"
      )
    );
    matIconRegistry.addSvgIconInNamespace(
      "custom_icon",
      "NavSliders",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/sideNavIcons/NavSliders.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "heroicons_outline",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/heroicons-outline.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "heroicons_solid",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/heroicons-solid.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "heroicons_mini",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/heroicons-mini.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "tablericons_outline",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/tablericons-outline.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "flags",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/images/flags/all_flags.svg"
      )
    );
    matIconRegistry.addSvgIconSetInNamespace(
      "tabler-icon",
      domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/tabler-icon.svg"
      )
    );
  }
}
